
export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '原始订单'
} as TCommon.RouteConfig
        